const filterByAvailability = async (properties, propertyAvailability, filter) => {
	const _properties = properties.map(p => {
		let value = propertyAvailability.find(v => v.airbetterId === p.id);
		p.availability = value ? value : false;
		return p;
	});
	const filters = {
        all: p => true,
        blocked: p =>  p.availability && (p.availability['admin-block'] > 0 || p.availability['host-block'] > 0),
        booked: p => p.availability && p.availability.reservation > 0,
        available: p => !p.availability || (p.availability.reservation + p.availability['admin-block'] + p.availability['host-block']) < p.availability.days || p.numberOfUnits > 1,
        fullAvailable : p => !p.availability || p.numberOfUnits > 1
    }
    const res = properties.filter(filters[filter]);
    return (res);
}

export default filterByAvailability;